import type { Session } from 'zitimail-shared-types';

/**
 * Fetches the current session from the BFF.
 *
 * The SPA holds no tokens — the BFF owns them and the browser carries only an
 * opaque cookie, so `credentials: 'include'` is what makes this work.
 */
export async function fetchSession(signal?: AbortSignal): Promise<Session> {
  const response = await fetch('/api/session', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
    ...(signal ? { signal } : {}),
  });

  // A 401 is the expected answer for a signed-out user, not an error to throw.
  if (response.status === 401) {
    return { authenticated: false };
  }
  if (!response.ok) {
    throw new Error(`session request failed with ${response.status}`);
  }

  return (await response.json()) as Session;
}
